<template>
  <div class="container-fluid">
    <div class="single-worker">
      <div class="row">
        <div class="col-md-6">
          <div class="worker">
            <div class="user-header">
              <div class="d-flex head">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xmlns:svgjs="http://svgjs.com/svgjs"
                  version="1.1"
                  width="25"
                  height="25"
                  x="0"
                  y="0"
                  viewBox="0 0 512 512"
                  style="enable-background: new 0 0 512 512"
                  xml:space="preserve"
                >
                  <g>
                    <g xmlns="http://www.w3.org/2000/svg">
                      <g>
                        <path
                          d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148    C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962    c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216    h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40    c59.551,0,108,48.448,108,108S315.551,256,256,256z"
                          fill="#000000"
                          data-original="#000000"
                        />
                      </g>
                    </g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                  </g>
                </svg>
              </div>
              <div>
                <h4>{{ worker.name }}</h4>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div>
                  <div class="d-flex gap-15">
                    <div>
                      <h6>العنوان</h6>
                    </div>
                    <div>
                      <h6>{{ worker.address }}</h6>
                    </div>
                  </div>

                  <div class="d-flex gap-15">
                    <div>الهاتف</div>
                    <div>
                      <h6>{{ worker.phone }}</h6>
                    </div>
                  </div>

                  <div class="d-flex gap-15">
                    <div>الحرفة</div>
                    <div>
                      <h6 v-if="worker.job">{{ worker.job.name }}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-wrap gap-3 worker-container">
            <div class="worker-card">
              <div>
                <div class="d-flex flex-column gap-1">
                  <div>
                    <h6 class="font-bold total">إجمالي الاتفاقيات</h6>
                  </div>
                  <div>
                    <h6>{{ total }}</h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="worker-card">
              <div>
                <div class="d-flex flex-column gap-1">
                  <h6 class="font-bold paied">المدفوع</h6>
                  <div>
                    <h6>{{ paid }}</h6>
                  </div>
                </div>
              </div>
            </div>

            <div class="worker-card">
              <div>
                <div class="d-flex flex-column gap-1">
                  <h6 class="font-bold reminder">المتبقي</h6>
                  <div>
                    <h6>{{ total - paid > 0 ? total - paid : 0 }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between mt-5 mb-2">
        <div>
          <h4>الإتفاقيات</h4>
        </div>
        <div>
          <el-button type="primary" plain @click="addDealModel = true">
            عقد إتفاقية
          </el-button>
        </div>
      </div>
      <el-table
        class="deals-table table-mobile"
        :data="worker.worker_deals"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          label="#"
          class-name="display-mobile-none"
        >
        </el-table-column>
        <el-table-column prop="project.name" label="المشروع">
          <template slot-scope="scope">
            <span class="label"> {{ scope.$index + 1 }} # المشروع </span>
            <div>{{ scope.row.project.name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="السعر">
          <template slot-scope="scope">
            <span class="label">السعر</span>
            <div>{{ scope.row.amount }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="paied" label="المدفوع">
          <template slot-scope="scope">
            <span class="label">المدفوع</span>
            <div>{{ scope.row.paied }}</div>
          </template>
        </el-table-column>
        <el-table-column label="المتبقي">
          <template slot-scope="scope">
            <span class="label">المتبقي</span>
            <div>{{ scope.row.amount - scope.row.paied }}</div>
          </template>
        </el-table-column>
        <el-table-column label="الوقت و التاريخ">
          <template slot-scope="scope">
            <span class="label">الوقت و التاريخ</span>
            <div>
              {{ $moment(scope.row.created_at).locale("ar").format("lll") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="الحالة">
          <template slot-scope="scope">
            <span class="label">الحالة</span>
            <div>
              <span
                class="status success"
                v-if="scope.row.amount <= scope.row.paied"
              >
                تم السداد
              </span>
              <span class="status danger" v-else> لم يتم التسديد </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="ملحوظة">
          <template slot-scope="scope">
            <span class="label">ملحوظة</span>
            <div>{{ scope.row.description }}</div>
          </template>
        </el-table-column>
        <el-table-column label="تعديل">
          <template slot-scope="scope">
            <el-button
              style="padding: 8px"
              @click="(updateDealModel = true), (updateDeal = { ...scope.row })"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                id="Icon"
                width="20"
                height="20"
                viewBox="0 0 20 20"
              >
                <rect
                  id="Area"
                  width="20"
                  height="20"
                  fill="#fcfcfc"
                  opacity="0"
                />
                <g
                  id="Icon-2"
                  data-name="Icon"
                  transform="translate(1.566 1.566)"
                >
                  <path
                    id="Path"
                    d="M9.167,3.333H15A1.667,1.667,0,0,1,16.667,5V16.667A1.666,1.666,0,0,1,15,18.333H3.334a1.667,1.667,0,0,1-1.667-1.666V10.833"
                    transform="translate(0.101 -1.566)"
                    fill="none"
                    stroke="#919efa"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.667"
                  />
                  <path
                    id="Path-2"
                    data-name="Path"
                    d="M9.684,2.083a1.768,1.768,0,0,0-2.5,2.5L15.1,12.5l3.333.833L17.6,10Z"
                    transform="translate(-6.667 -1.566)"
                    fill="none"
                    stroke="#919efa"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.667"
                  />
                </g>
              </svg>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column type="expand">
          <template slot-scope="props">
            <div style="padding: 15px">
              <div class="mt-3 d-flex align-items-center">
                <el-button
                  v-if="props.row.amount > props.row.paied"
                  type="primary"
                  @click="(currDeal = props.row), (addDealPaymentModel = true)"
                  plain
                >
                  إضافة مبلغ
                </el-button>
                <el-button
                  v-if="props.row.payments && props.row.payments.length > 0"
                  @click="openPrintScreen(props.row)"
                >
                  طباعة
                </el-button>
              </div>
              <el-table class="table-mobile" :data="props.row.payments">
                <el-table-column
                  width="100"
                  type="index"
                  label="#"
                  class-name="display-mobile-none"
                />
                <el-table-column width="200" prop="amount" label="المبلغ">
                  <template slot-scope="scope">
                    <span class="label">{{ scope.$index + 1 }} # المبلغ</span>
                    <div>{{ scope.row.amount }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="description" label="التعليق">
                  <template slot-scope="scope">
                    <span class="label">التعليق</span>
                    <div>{{ scope.row.description }}</div>
                  </template>
                </el-table-column>
                <el-table-column width="200" label="تاريخ الإنشاء">
                  <template slot-scope="scope">
                    <span class="label">تاريخ الإنشاء</span>
                    <div>
                      {{
                        $moment(scope.row.created_at).locale("ar").format("lll")
                      }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column width="200" label="اخر تعديل">
                  <template slot-scope="scope">
                    <span class="label">اخر تعديل</span>
                    <div>
                      {{
                        $moment(scope.row.updated_at).locale("ar").format("lll")
                      }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column width="200" label="حذف">
                  <template slot-scope="scope">
                    <el-popconfirm
                      title="متأكد من انك تريد الحذف ؟"
                      @confirm="deletePaymentDeal(scope.row)"
                    >
                      <el-button type="danger" slot="reference">حذف</el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <vs-popup
      class="popup-width-300"
      title="عقد إتفاق"
      :active.sync="addDealModel"
    >
      <div class="popup-calender">
        <el-form :model="addDeal" ref="addDeal">
          <h6 class="mb-1">الوصف</h6>
          <el-form-item
            prop="description"
            :rules="[{ required: true, message: 'الوصف مطلوب' }]"
          >
            <el-input
              placeholder="الوصف"
              v-model="addDeal.description"
            ></el-input>
          </el-form-item>

          <h6 class="mb-1">المبلغ</h6>
          <el-form-item
            prop="amount"
            :rules="[{ required: true, message: 'المبلغ مطلوب' }]"
          >
            <el-input
              @focus="$event.target.select()"
              type="number"
              placeholder="المبلغ"
              v-model="addDeal.amount"
            ></el-input>
          </el-form-item>

          <h6 class="mb-1">إختر المشروع</h6>
          <el-form-item
            prop="project_id"
            :rules="[{ required: true, message: 'المشروع مطلوبة' }]"
          >
            <el-select
              v-model="addDeal.project_id"
              placeholder="المشروع"
              style="width: 100% !important"
            >
              <el-option
                v-for="item in projects"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="onSubmit('addDeal')">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <vs-popup
      class="popup-width-300"
      title="تعديل إتفاق"
      :active.sync="updateDealModel"
    >
      <div class="popup-calender">
        <el-form :model="updateDeal" ref="updateDeal">
          <h6 class="mb-1">الوصف</h6>
          <el-form-item
            prop="description"
            :rules="[{ required: true, message: 'الوصف مطلوب' }]"
          >
            <el-input
              placeholder="الوصف"
              v-model="updateDeal.description"
            ></el-input>
          </el-form-item>

          <h6 class="mb-1">المبلغ</h6>
          <el-form-item
            prop="amount"
            :rules="[{ required: true, message: 'المبلغ مطلوب' }]"
          >
            <el-input
              type="number"
              @focus="$event.target.select()"
              placeholder="المبلغ"
              v-model="updateDeal.amount"
            ></el-input>
          </el-form-item>

          <h6 class="mb-1">إختر المشروع</h6>
          <el-form-item
            prop="project_id"
            :rules="[{ required: true, message: 'المشروع مطلوبة' }]"
          >
            <el-select
              v-model="updateDeal.project_id"
              placeholder="المشروع"
              style="width: 100% !important"
            >
              <el-option
                v-for="item in projects"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button
                type="primary"
                @click="onSubmitUpdateDeal('updateDeal')"
              >
                تعديل
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <vs-popup
      class="popup-width-300"
      title="سداد دفعة من الاتفاق"
      :active.sync="addDealPaymentModel"
    >
      <div class="popup-calender">
        <el-form :model="addDealPayment" ref="addDealPayment">
          <h6 class="mb-1">المبلغ</h6>
          <el-form-item
            prop="amount"
            :rules="[{ required: true, message: 'المبلغ مطلوب' }]"
          >
            <el-input
              type="number"
              placeholder="المبلغ"
              v-model="addDealPayment.amount"
            ></el-input>
          </el-form-item>
          <!-- description -->
          <h6 class="mb-1">تعليق</h6>

          <el-form-item prop="description">
            <el-input
              type="textarea"
              placeholder="تعليق"
              v-model="addDealPayment.description"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button
                type="primary"
                @click="onSubmitDealPayment('addDealPayment')"
              >
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
// import { ipcRenderer } from "electron";

export default {
  mounted() {
    this.getWorker();
    // this.worker = JSON.parse(localStorage.getItem("currWorker"));
    this.getProjects();
  },
  data() {
    return {
      updateDealModel: false,
      updateDeal: {},
      worker: {},
      addDealPayment: {},
      projects: [],
      addDeal: {},
      residual: 0,
      total: 0,
      currDeal: {},
      paid: 0,
      addDealPaymentModel: false,
      addDealModel: false,
    };
  },
  methods: {
    async deletePaymentDeal(deal) {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      try {
        await axiosApi.delete(`/worker_deal_payments/${deal.id}`);
        this.$vs.notify({
          title: "تم",
          position: "top-center",
          color: "success",
          text: `تم الحذف بنجاح`,
        });
        this.getWorker();
        this.getProjects();
      } catch {
        this.$vs.notify({
          title: "خطأ",
          position: "top-center",
          color: "danger",
          text: `حدث خطأ ما`,
        });
      } finally {
        loading.close();
      }
    },
    openPrintScreen(deal) {
      console.log(deal);

      // window.ipcRenderer = ipcRenderer;

      // ipcRenderer.send("print_worker_deals", { ...deal, worker: this.worker });
    },
    getProjects() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get("/projects")
        .then((res) => {
          this.projects = res.data;
        })
        .finally(() => loading.close());
    },
    getWorker() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get(`/workers/${this.$route.params.id}`)
        .then((res) => {
          this.worker = res.data;
          if (res.data.worker_deals.length > 0) {
            this.total = res.data.worker_deals.reduce((prev, curr) => {
              console.log(prev, curr);
              return prev + curr.amount;
            }, 0);

            this.paid = res.data.worker_deals.reduce((prev, curr) => {
              console.log(prev, curr);
              return prev + curr.paied;
            }, 0);
          }
        })
        .finally(() => loading.close());
    },
    onSubmitDealPayment(formName) {
      if (
        this.currDeal.amount - this.currDeal.paied <
        this.addDealPayment.amount
      ) {
        this.$vs.notify({
          title: "السعر اكبر من قيمة الاتفاق",
          position: "top-center",
          color: "danger",
          text: `ادخل سعر اقل من او يساوي ${
            this.currDeal.amount - this.currDeal.paied
          }`,
        });
        return;
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .post("/worker_deals/payments", {
              ...this.addDealPayment,
              worker_deal_id: this.currDeal.id,
              worker: this.worker,
            })
            .then(() => {
              this.addDealPaymentModel = false;
              this.addDealPayment = {};
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الاضافة بنجاح",
              });
              this.getWorker();
            })
            .catch((err) => {
              if (err.response.status == 500) {
                this.$vs.notify({
                  title: " عذرا",
                  position: "top-center",
                  color: "danger",
                  text: "حدث خطا ما",
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },

    onSubmitUpdateDeal(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .put(`/worker_deals/${this.updateDeal.id}`, {
              ...this.updateDeal,
              worker_id: this.$route.params.id,
            })
            .then(() => {
              this.updateDealModel = false;
              this.updateDeal = {};
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم التعديل بنجاح",
              });
              this.getWorker();
            })
            .catch((err) => {
              if (err.response.status == 500) {
                this.$vs.notify({
                  title: " عذرا",
                  position: "top-center",
                  color: "danger",
                  text: "حدث خطا ما",
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .post("/worker_deals", {
              ...this.addDeal,
              worker_id: this.$route.params.id,
            })
            .then(() => {
              this.addDealModel = false;
              this.addDeal = {};
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الاضافة بنجاح",
              });
              this.getWorker();
            })
            .catch((err) => {
              if (err.response.status == 500) {
                this.$vs.notify({
                  title: " عذرا",
                  position: "top-center",
                  color: "danger",
                  text: "حدث خطا ما",
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },
  },
};
</script>

<style lang="scss">
.single-worker {
  padding: 10px;
  .worker {
    padding: 10px;
    box-shadow: 1px 0 23px 0 #0000000a;
    border-radius: 15px;
    background: #fff;
  }
  .worker-card {
    background: #fff;
    padding: 15px 25px;
    box-shadow: 1px 0 23px 0 #0000000a;
    border-radius: 15px;
    min-width: 160px;
    h6 {
      font-size: 16px;
      text-align: center !important;
    }
    .total {
      color: var(--bs-primary);
    }
    .paied {
      color: var(--bs-success);
    }
    .reminder {
      color: var(--bs-danger);
    }
  }
  .user-header {
    display: flex;
    gap: 15px;
    margin-bottom: 10px;
    h6 {
      margin-bottom: 0;
    }
    .head {
      gap: 10px;
      svg {
        padding: 5px;
        background-color: rgba(var(--vs-primary), 0.3) !important;
        border-radius: 5px;
        path {
          fill: #fff;
        }
      }
    }
  }

  .status {
    padding: 5px 10px;
    border-radius: 10px;
    color: #fff;
    text-align: center;
    text-wrap: nowrap;

    &.danger {
      border: 1px solid #ffe5e5;
      color: #ff0000;
      background: #ffe5e5;
    }
    &.success {
      border: 1px solid #f2f9f1;
      color: #a8d8a5;
      background: #f2f9f1;
    }
  }

  .deals-table {
    .cell {
      padding: 5px;
      div {
        padding: 5px;
      }
    }
    .el-table {
      margin: 15px 0;
      .el-table__header {
        // margin: auto;
      }
      .el-table__body {
        // margin: auto;
      }
    }
  }

  .gap-15 {
    gap: 15px;
    margin-bottom: 10px;
  }
  .justify-content-between {
    justify-content: space-between !important;
  }
}
</style>
